var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVelas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0C6.93935 0 5.06639e-07 6.93935 5.06639e-07 15.5C5.06639e-07 24.0606 6.93935 31 15.5 31C24.0606 31 31 24.0606 31 15.5C31 6.93935 24.0606 0 15.5 0Z",
    fill: "#0037C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0156 14.608L15.4318 20.6282L18.8488 14.608H12.0156V14.608ZM8.59785 12.6015H22.2665L15.4318 24.6419L8.59785 12.6015ZM24.5443 8.58777L23.405 10.5942H7.45938L6.3209 8.58777H24.5443Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVelas);
export default __webpack_public_path__ + "static/media/velas.e8f0bd4d257f99e2fdbb8a5f0c2f3c61.svg";
export { ForwardRef as ReactComponent };